import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { PagePropertiesContext, } from './PageLifecycleProvider';
export var PageProps = function (_a) {
    var pageProperties = _a.pageProperties, children = _a.children;
    var pagePropsRef = React.useRef(pageProperties || {});
    pagePropsRef.current = pageProperties || {};
    var pageProps = React.useContext(PagePropertiesContext);
    if (pageProps.currentPageProps.indexOf(pagePropsRef) === -1) {
        pageProps.currentPageProps.push(pagePropsRef);
    }
    React.useEffect(function () {
        return function () {
            // On unmount, delete the props
            pageProps.currentPageProps.splice(pageProps.currentPageProps.indexOf(pagePropsRef), 1);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (typeof children === 'function') {
        return (_jsx(Fragment, { children: children({
                beginLoadingData: pageProps.beginLoadingData,
                endLoadingData: pageProps.endLoadingData,
            }) }));
    }
    if (children) {
        return _jsx(Fragment, { children: children });
    }
    return null;
};
PageProps.displayName = 'PageProps';
//# sourceMappingURL=PageProps.js.map